import React, { Dispatch, SetStateAction } from 'react';

import { AssetDetail } from '@atom/types/asset';
import { AssetRequest, AssetRequestStatus } from '@atom/types/assetRequest';

interface Context {
  fromAsset: AssetDetail;
  activeRequest: AssetRequest;
  handleGetActiveRequest: () => void;
  setActiveRequestId: (id: string) => void;
  status: AssetRequestStatus;
  setStatus: Dispatch<SetStateAction<AssetRequestStatus>>;
  quantityApproved: number;
  setQuantityApproved: Dispatch<SetStateAction<number>>;
  comments: string;
  setComments: Dispatch<SetStateAction<string>>;
  confirmOpen: boolean;
  setConfirmOpen: Dispatch<SetStateAction<boolean>>;
  onAssetRefresh?: () => void;
  onReplenishmentSaved?: (request: AssetRequest) => void;
}

export const initialState: Context = {
  // @ts-ignore
  fromAsset: {},
  // @ts-ignore
  activeRequest: {},
  handleGetActiveRequest: () => {},
  setActiveRequestId: () => {},
  status: null,
  setStatus: () => {},
  quantityApproved: null,
  setQuantityApproved: () => {},
  comments: null,
  setComments: () => {},
  confirmOpen: false,
  setConfirmOpen: () => {},
};

const ViewRequestContext = React.createContext<Context>(initialState);

export default ViewRequestContext;
